import React, { useState, useContext } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
// import {CustomDate} from '../../components/CustomForm'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData, updateDocumentByID, axiosAuth } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'
import {UseBeatPlan} from '../../hooks/beatPlan/useBeatPlan'
import { useChannelType } from '../../hooks/CompanyConfiguration/useChannelType'
import {useSalesChannelType} from '../../hooks/CompanyConfiguration/useSalesChannelType'
//? Material-ui
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import { IconButton } from '@material-ui/core'
import { BeatPlanContext } from '../../context api/BeatPlan/BeatPlanContext'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { Grid } from '@material-ui/core'
import CustomDatePicker from '../../components/CustomDatePicker'
import CustomSelect from '../../components/CustomSelect'
import GeoLocation  from './geoLocation'
import Layout from '../../components/Layout'

export default function BeatPlans() {
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate.toISOString())
  const [to, setTo] = React.useState(new Date().toISOString())
  const [channelType, setChannelType] = React.useState("");
  const [channelName, setChannelName] = React.useState("");
  const [searchQuery, setSearchQuery] = useState('')
  const debouncedValue = useDebounce(searchQuery, 500)
  const {getAllBeatPlan, deleteMany,BulkUploadBeatPlan, addBeatPlan, pdfCsvData} = UseBeatPlan();
  const {beatPlans, loading, addNewBeatPlan} =useContext(BeatPlanContext)
  const { channelTypes, salesChannelTypes } = useContext(ConfigurationContext)
  const {getAllChannelType}  = useChannelType();
  const { getAllSalesChannelType } = useSalesChannelType()
  const [page, setPage] = React.useState(1)
  const limit = 15;
  const noOfPages = 100;
  const [tmpArr, setTmpArr]= useState([]);
  const queryClient = useQueryClient()

  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }


  React.useEffect(()=> {
    getAllBeatPlan({ page: page, limit: limit, channelName: channelName, channelType: channelType, from : from, to: to, sortObj: {date: -1}});
    console.log("beats", beatPlans)    
  }, [from, to, page, channelName, channelType])

  React.useEffect(()=> {
    let tmp= [];
    console.log("beat plans", beatPlans)
    if(beatPlans.length === 0) setTmpArr([]);
    else if (beatPlans?.length > 0) {
      tmp= beatPlans?.map((item) => {
        return ([
          { type: 'CHECKBOX', _id: item?._id },
          { value: item?.createdBy?.firstName + item?.createdBy?.lastName },
          { value: item?.createdBy?.userType },
          { value: item?.channelName?.name },
          { value: item?.channelType?.name },
          {
              value: (
                <>
                  {item?.status === 'APPROVED' && <div style= {{color: "green"}}>Approved</div>}
                  {item?.status === 'REJECTED' && <div style= {{color: "red"}}>Rejected</div>}
                  {item?.status === 'PENDING' && (
                    <>
                      <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleAcceptRequest(item?._id)}>
                        <CheckIcon style={{ color: 'blue' }} />{' '}
                      </IconButton>
                      <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleRejectRequest(item?._id)}>
                        <ClearIcon style={{ color: 'red' }} />{' '}
                      </IconButton>
                    </>
                  )}
                </>
              ),
            },
          { value: item?.employee?.firstName },
          { value: item?.state?.name },
          { value: item?.city?.name },
          { value: item?.date },
        ])
      })
    }
    console.log(tmp);
    setTmpArr(tmp);
  }, [beatPlans])

  React.useEffect(() => {
    getAllChannelType()
    console.log("channelTypes====================>", channelTypes);
  }, [])

  React.useEffect(() => {
    if(channelType){
      getAllSalesChannelType({ page: 1, channelType: channelType})
    }
  }, [channelType])

  React.useEffect(() => {
    console.log(salesChannelTypes)
  }, [salesChannelTypes])
  const handleAcceptRequest = async (id, data) => {
    const response = await axiosAuth.put(`beat/plan/${id}/accept`)
    console.log(response)
    queryClient.invalidateQueries('beat-plan')
    
    window.location.reload()
  }
  const handleRejectRequest = async (id, data) => {
    const response = await axiosAuth.put(`beat/plan/${id}/reject`)
    console.log(response)
    queryClient.invalidateQueries('beat-plan')

    window.location.reload()

  }   
  const channelInput = [
    {
      label: 'Select Channel Type',
      value: channelType,
      name: 'channelType',
      fieldName: 'name',
      fieldValue: '_id',
      options: channelTypes,
      handleChange: setChannelType
   },
    // {
    //   label: 'Channel Name',
    //   value: channelName,
    //   name: 'channelName',
    //   fieldName: 'name',
    //   fieldValue: '_id',
    //   options: salesChannelTypes,
    //   handleChange: setChannelName
    // },  
  ]

  const layoutProps = {
    heading: 'Beat Plan Requests',
    url: ROUTES.ADD_BEAT_PLAN,
    editUrl: '/edit-beat-plan/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    permissionName: 'BEAT',
    filename: 'beat',
    sampleName: 'sample_beat',
    sheetName: 'beats',
    addData: addNewBeatPlan,
    setPage,
    tempHeaders : ["channelName", "channelType", "date", "employee", "state", "city"],
    tempHeaderData : [["supply1", "Supply", "2022-07-11", "Mohit Kumar", "DELHI", "DELHI"]],
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    handleUploadFile: BulkUploadBeatPlan
  }

  return (
    <>

      <CustomTableLayout
        tableHeadings={['Created by', 'Created by Type', 'Channel Name', 'Channel Type', 'Status', 'Created for', 'State', 'City', 'Date']}
        loading={false}
        tableBody={tmpArr}
        layoutProps={layoutProps}
        checkbox
        paginate={{ totalPage: noOfPages, page: page }}
        deleteMany={(val, setSelected) => deleteMany({ids:val}, setSelected) }
        handlePageChange={handlePageChange}
        to = {to}
        from = {from}
        setTo = {setTo}
        setFrom = {setFrom}
        channelInput = {channelInput}
      />

    
    </>
  )
}

   